// extracted by mini-css-extract-plugin
module.exports = {"spin":"animations_spin__1VN_0","spinner":"PlayPage_spinner__2EsQv","spinner__icon":"PlayPage_spinner__icon__2bHnd"};